
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {CounterInfo} from './CounterInfo';
import {FieldModelCounterInfo} from './CounterInfo';
import {SymbolCounterInfo} from './SymbolCounterInfo';
import {FieldModelSymbolCounterInfo} from './SymbolCounterInfo';

/**
 * TradeModuleInfo struct
 */
class TradeModuleInfo {
  /**
   * Initialize struct
   * @param {!CounterInfo=} orderInfo
   * @param {!Array=} topSymbolOrderInfo
   * @constructor
   */
  constructor (orderInfo = new CounterInfo(), topSymbolOrderInfo = []) {
    this.OrderInfo = orderInfo
    this.TopSymbolOrderInfo = topSymbolOrderInfo
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TradeModuleInfo}
   * @param {!TradeModuleInfo} other Other struct
   * @returns {!TradeModuleInfo} This struct
   */
  copy (other) {
    if (other.OrderInfo != null) {
      this.OrderInfo = CounterInfo.fromObject(other.OrderInfo)
    } else {
      this.OrderInfo = null
    }
    if (other.TopSymbolOrderInfo != null) {
      this.TopSymbolOrderInfo = []
      for (let item of other.TopSymbolOrderInfo) {
        if (item != null) {
          let tempItem
          tempItem = SymbolCounterInfo.fromObject(item)
          this.TopSymbolOrderInfo.push(tempItem)
        } else {
          this.TopSymbolOrderInfo.push(null)
        }
      }
    } else {
      this.TopSymbolOrderInfo = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TradeModuleInfo}
   * @returns {!TradeModuleInfo} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TradeModuleInfoModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TradeModuleInfoModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TradeModuleInfo}
   * @param {!TradeModuleInfo} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradeModuleInfo)) {
      throw new TypeError('Instance of TradeModuleInfo is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TradeModuleInfo}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      OrderInfo: ((this.OrderInfo != null) ? this.OrderInfo : null),
      TopSymbolOrderInfo: ((this.TopSymbolOrderInfo != null) ? Array.from(this.TopSymbolOrderInfo, item => ((item != null) ? item : null)) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TradeModuleInfo.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TradeModuleInfo} other Object value
   * @returns {!TradeModuleInfo} Created struct
   */
  static fromObject (other) {
    return new TradeModuleInfo().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TradeModuleInfo}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TradeModuleInfo.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TradeModuleInfo}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 77
  }
}

export { TradeModuleInfo };

/**
 * Fast Binary Encoding TradeModuleInfo field model
 */
class FieldModelTradeModuleInfo extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.OrderInfo = new FieldModelCounterInfo(buffer, 4 + 4)
    this.TopSymbolOrderInfo = new fbe.FieldModelVector(new FieldModelSymbolCounterInfo(buffer, this.OrderInfo.fbeOffset + this.OrderInfo.fbeSize), buffer, this.OrderInfo.fbeOffset + this.OrderInfo.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelTradeModuleInfo}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTradeModuleInfo}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.OrderInfo.fbeSize + this.TopSymbolOrderInfo.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTradeModuleInfo}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.OrderInfo.fbeExtra + this.TopSymbolOrderInfo.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTradeModuleInfo}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTradeModuleInfo.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTradeModuleInfo}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 77
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTradeModuleInfo}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTradeModuleInfo}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.OrderInfo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderInfo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderInfo.fbeSize

    if ((fbeCurrentSize + this.TopSymbolOrderInfo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TopSymbolOrderInfo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TopSymbolOrderInfo.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTradeModuleInfo}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTradeModuleInfo}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTradeModuleInfo}
   * @param {!TradeModuleInfo} fbeValue Default value, defaults is new TradeModuleInfo()
   * @returns {!TradeModuleInfo} TradeModuleInfo value
   */
  get (fbeValue = new TradeModuleInfo()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTradeModuleInfo}
   * @param {!TradeModuleInfo} fbeValue TradeModuleInfo value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.OrderInfo.fbeSize) <= fbeStructSize) {
      fbeValue.OrderInfo = this.OrderInfo.get()
    } else {
      fbeValue.OrderInfo = new CounterInfo()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderInfo.fbeSize

    if ((fbeCurrentSize + this.TopSymbolOrderInfo.fbeSize) <= fbeStructSize) {
      this.TopSymbolOrderInfo.get(fbeValue.TopSymbolOrderInfo)
    } else {
      fbeValue.TopSymbolOrderInfo.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TopSymbolOrderInfo.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTradeModuleInfo}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTradeModuleInfo}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTradeModuleInfo}
   * @param {!TradeModuleInfo} fbeValue TradeModuleInfo value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTradeModuleInfo}
   * @param {TradeModuleInfo} fbeValue TradeModuleInfo value
   */
  setFields (fbeValue) {
    this.OrderInfo.set(fbeValue.OrderInfo)
    this.TopSymbolOrderInfo.set(fbeValue.TopSymbolOrderInfo)
  }
}

export { FieldModelTradeModuleInfo };

/**
 * Fast Binary Encoding TradeModuleInfo model
 */
class TradeModuleInfoModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTradeModuleInfo(this.buffer, 4)
  }

  /**
   * Get the TradeModuleInfo model
   * @this {!TradeModuleInfoModel}
   * @returns {!FieldModelTradeModuleInfo} model TradeModuleInfo model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TradeModuleInfoModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TradeModuleInfoModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TradeModuleInfoModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TradeModuleInfoModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTradeModuleInfo.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TradeModuleInfoModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TradeModuleInfoModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TradeModuleInfoModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TradeModuleInfoModel}
   * @param {!TradeModuleInfo} value TradeModuleInfo value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TradeModuleInfoModel}
   * @param {!TradeModuleInfo} value TradeModuleInfo value, defaults is new TradeModuleInfo()
   * @return {!object} Deserialized TradeModuleInfo value and its size
   */
  deserialize (value = new TradeModuleInfo()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TradeModuleInfo(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TradeModuleInfo(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TradeModuleInfoModel}
   * @param {!number} prev Previous TradeModuleInfo model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TradeModuleInfoModel };
